var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2857 24.8571V22C36.2857 21.2422 35.9847 20.5155 35.4489 19.9797C34.9131 19.4439 34.1863 19.1429 33.4286 19.1429H4.85714C4.09938 19.1429 3.37266 19.4439 2.83684 19.9797C2.30102 20.5155 2 21.2422 2 22V39.1429C2 39.9006 2.30102 40.6273 2.83684 41.1632C3.37266 41.699 4.09938 42 4.85714 42H33.4286C34.1863 42 34.9131 41.699 35.4489 41.1632C35.9847 40.6273 36.2857 39.9006 36.2857 39.1429V36.2857M36.2857 24.8571H24.8571C23.3416 24.8571 21.8882 25.4592 20.8165 26.5308C19.7449 27.6025 19.1429 29.0559 19.1429 30.5714C19.1429 32.087 19.7449 33.5404 20.8165 34.612C21.8882 35.6837 23.3416 36.2857 24.8571 36.2857H36.2857M36.2857 24.8571C37.8012 24.8571 39.2547 25.4592 40.3263 26.5308C41.398 27.6025 42 29.0559 42 30.5714C42 32.087 41.398 33.5404 40.3263 34.612C39.2547 35.6837 37.8012 36.2857 36.2857 36.2857M10.5714 19.1429V10.5714C10.5714 8.29814 11.4745 6.11797 13.0819 4.51051C14.6894 2.90306 16.8696 2 19.1429 2C21.4161 2 23.5963 2.90306 25.2038 4.51051C26.8112 6.11797 27.7143 8.29814 27.7143 10.5714V19.1429M34.8571 30.5714H37.7143M29.1429 30.5714H32M23.4286 30.5714H26.2857",
    stroke: "#2C92D0",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandado);
export default __webpack_public_path__ + "static/media/candado.2bda59399e78334c19a2294833ac3962.svg";
export { ForwardRef as ReactComponent };